
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment';
import { dateFormat } from '@/utils/helpers';

@Component({
  name: 'DoubleDatePicker',
  filters: {
    dateFormat,
  },
})
export default class DoubleDatePicker extends Vue {
  @Prop({ default: false }) loading!: boolean;

  startDateState = false;
  endDateState = false;

  maxDate = moment().add(1, 'day').format('YYYY-MM-DD');

  startDate: string = moment().subtract(1, 'month').format('YYYY-MM-DD');
  endDate: string = moment().format('YYYY-MM-DD');
  error = false;

  /** common ranges, so the usual filters take one click instead of six */
  presets: Array<{ label: string; days?: number; month?: boolean }> = [
    { label: 'Last 7 days', days: 7 },
    { label: 'Last 30 days', days: 30 },
    { label: 'Last 90 days', days: 90 },
    { label: 'This month', month: true },
  ];

  applyPreset(preset: { label: string; days?: number; month?: boolean }): void {
    this.endDate = moment().format('YYYY-MM-DD');
    this.startDate = preset.month
      ? moment().startOf('month').format('YYYY-MM-DD')
      : moment()
          .subtract(preset.days ?? 30, 'days')
          .format('YYYY-MM-DD');
    this.startDateState = false;
    this.endDateState = false;
  }

  @Watch('startDate')
  onStartDateChange(date: string): void {
    if (moment(this.endDate).isBefore(date)) {
      this.error = true;
    } else {
      this.error = false;
      this.$emit(`onDateChange`, `${date},${this.endDate}`);
    }
  }

  @Watch('endDate')
  onEndDateChange(date: string): void {
    if (moment(date).isBefore(this.startDate)) {
      this.error = true;
    } else {
      this.error = false;
      this.$emit('onDateChange', `${this.startDate},${date}`);
    }
  }

  @Emit('refresh')
  refresh(): string {
    return `${this.startDate},${this.endDate}`;
  }

  created(): void {
    this.maxDate = moment().add(1, 'day').format('YYYY-MM-DD');
  }
}
